import React,{useEffect,useState,useContext} from 'react'
import axios from 'axios'
import { ManagerAuthContext } from "../context/AuthManager";
import { ToastContainer, toast } from "react-toastify";

export const Diagnosis = () => {

const { currentUserRF } = useContext(ManagerAuthContext);

const [code,setCode] = useState('')
const [name,setName] = useState('')
const [price,setPRice] = useState('')

const handelServ = async() =>{
    await axios.post("https://clinic.salamatpayanew.ir/admin/registerDiagnois",{
        code:code,
        name:name,
        price:price,
        nezam:currentUserRF.nezam
    }).then(() =>{
        toast.success("ثبت انجام شد")
    }).catch((err) =>{
        console.log(err)
        toast.error("خطا در ثبت اطلاعات")
    })
}

const [userList, setUserList] = useState([]);

useEffect(() => {
const getAllProductsRT = async () => {
    const res = await fetch(
    `https://clinic.salamatpayanew.ir/admin/ListServicesDiagnoz/${currentUserRF.nezam}`
    );
    setUserList(await res.json());
};
  getAllProductsRT();
}, [userList]);

const handelDelete = async(id) => {
    try{
       axios
      .delete(`https://clinic.salamatpayanew.ir/admin/deleteDiagones/${id}`)
      .then((response) => {
        setUserList((values) => {
          return values.filter((item) => item.id !== id);
        });
        toast.success("حذف  با موفقیت انجام شد");
      });
    }catch(err){
        toast.error("عملیات حذف غیر فعال میباشد")
    }
}


if (currentUserRF.meli === null) {

} else {

return (
   <>
<section class="m-0 content" dir='rtl'>
<div class="d-flex flex-column justify-content-start align-items-center">
    <div class="card">
        <img src="../img/dr02.png" class="position-absolute form-img" alt="" />
        <div class="d-flex flex-column justify-content-start card-title-container">
            <div class="card-title text-secondary">ثبت تشخیص</div>
        </div>
    <br />
    <p></p>
        <div class="d-flex flex-column flex-md-row justify-content-between w-100 t-8">
            <div class="custom-form-control form-group position-relative w-50">
                <input type="text" class="form-control pr-16 my-2" placeholder="کد تشخیص" onChange={(e) => setCode(e.target.value)} />
            </div>
            <div class="custom-form-control form-group position-relative w-50 m-0 mx-md-3">
                <input type="text" class="form-control pr-16 my-2" placeholder="نام تشخیص" onChange={(e) => setName(e.target.value)} />
            </div>
        </div>
        <p></p>
        <button className='btn btn-danger col-sm-3' onClick={handelServ}>تایید تشخیص</button>
    </div>
</div>
</section>
   <p></p>
   <section class="m-0 content" dir='rtl'>
            <h5>لیست تشخیص ها</h5>
            <div class="row">
                <div class="table-responsive">
                    <table class="table bg-white custom-rounded t-24 table-responsive">
                        <thead>
                            <tr class="text-center">
                                 <th><span>ردیف</span></th>
                                <th><span>کد تشخیص</span></th>
                                <th><span>نام تشخیص</span></th>
                                <th><span>حذف</span></th>
                            </tr>
                        </thead>
                    {userList
                .map((item, index) => {
                    const { id, name,nezam,year } = item;
                  return (
                    <tbody
                      class="table-group-divider table-divider-color"
                      key={item.id}>
                            <tr>
                                <td>{index +1}</td>
                                <td>{item.code}</td>
                                <td>{item.name}</td>
                                <td>
                                    <img src="/img/del.png" height={"25px"} width={"25px"} style={{cursor:'pointer'}} onClick={() =>handelDelete(id)} />
                                </td>
                            </tr>
                        </tbody>
                    );
                })}
                    </table>

                </div>
            </div>
        </section>
   
<ToastContainer
        position="top-center"
        autoClose={20000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      
   </>
  )
  }
}

